import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card/Card";
import CardHeader from "@material-ui/core/CardHeader/CardHeader";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Typography from "@material-ui/core/Typography/Typography";
import clientSnapshot from "../images/client_snapshot.svg";
import { IconButton, Link, List, Tooltip } from "@material-ui/core";
import { useSelector } from "react-redux";
import { RootState } from "../../../../reducers";
import { dateUtils } from "../../../../../src/utils";
import { getPolicyStatus } from "../../../../model";
import numeral from "numeral";
import { isMobile } from "react-device-detect";
import moment from "moment";
import InfoIcon from "@material-ui/icons/Info";
import { TooltipProps } from "@material-ui/core/Tooltip";
import { maskCurrencyWithDecimal } from "../../../../utils/commonUtils";
import { clientSource, GWT_GEN2_STRATEGY, PolicyStatusEnum } from "../../../../constants";
import EditIcon from "@material-ui/icons/Edit";
import TrancheNumberPopUp from "./TrancheNumberPopUp";
import { Link as RouterLink } from "react-router-dom";
import ViewServicing from "../../../../components/client/ViewServicing";
import { fullName } from "./tabs/ClientProfileTab";
import { usePolicyContext } from "../../../../components/clientServicing/Payments/PolicyContext";
import LockIcon from "@material-ui/icons/Lock";

const useStylesBootstrap = makeStyles((theme: Theme) => ({
    arrow: {
        color: theme.palette.common.black,
    },
    tooltip: {
        backgroundColor: theme.palette.common.black,
    },
}));

function BootstrapTooltip(props: TooltipProps) {
    const classes = useStylesBootstrap();

    return <Tooltip arrow classes={classes} {...props} />;
}

const ClientSnapshot = (props: { mobileContent?: boolean, refreshDetails?: Function, caseDetailButtonRef?: any }) => {
    const {mobileContent = false, caseDetailButtonRef} = props;
    const [trancheSelectBox, setTrancheSelectBox] = React.useState(false);
    const detail: any = useSelector((state: RootState) => state.clientAccount);
    const user: any = useSelector((state: RootState) => state.auth.user);
    const clientPolicy = detail && detail.client && detail.client.clientPolicies.length > 0 && detail.client.clientPolicies[0];
    let lastLogin: any = detail && detail.lastLogin;
    let currentStatus: any = (detail && detail.inviteStatus) || 0;
    let currentPolicyStatus: any = clientPolicy && clientPolicy.currentPolicyStatus || "";
    let currentPolicySubStatus: any = clientPolicy && clientPolicy.currentPolicySubStatus || "";
    let advisor: any = clientPolicy && clientPolicy.agent && clientPolicy.agent.user;
    let carrierName: any = clientPolicy && clientPolicy.carrier && clientPolicy.carrier.carrierName;
    let clientListName = (clientPolicy && clientPolicy.clientlist && clientPolicy.clientlist.clientListName) || '';
    let companyName = (clientPolicy && clientPolicy.company && clientPolicy.company.companyName) || '';
    let trancheNo = clientPolicy && clientPolicy.tranche && clientPolicy.tranche.trancheNumber || "";

    const source: string = detail && detail.client && detail.client.source;
    let thisYearContributionAmountDue = (clientPolicy && clientPolicy.issuedContribution) || "";
    let contributionAmount = (clientPolicy && clientPolicy.contributionAmount) || "";
    contributionAmount = thisYearContributionAmountDue || contributionAmount;
    let strategyName = (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.displayName) || "Kai-Zen";
    let targetAmount = clientPolicy && clientPolicy.benefitAmounts && clientPolicy.benefitAmounts.targetAmount;
    const isGWTGen2 = (clientPolicy && clientPolicy.strategyId === GWT_GEN2_STRATEGY)
    const { policy }: any = usePolicyContext();
    const openTrancheSelect = () => {
        if (caseDetailButtonRef && caseDetailButtonRef.current) {
            caseDetailButtonRef.current.click();
        }
        setTrancheSelectBox(true);
    }
    const policyRow = policy && policy.clientPayments && policy.clientPayments.filter(payment => !!(payment.amount)).length > 0;
    return (

                <>
                {
                    isMobile && !mobileContent ? "" :
                            <>
                                {
                                        (user.role === 1 || user.role === 2) &&
                                        <TrancheNumberPopUp trancheSelectBox={trancheSelectBox}
                                                            setTrancheSelectBox={setTrancheSelectBox}
                                                            clientDetail={detail}
                                                            refreshDetails={props.refreshDetails}
                                        />

                                }

                                <CardSnapshot title="Client Snapshot">
                                    <CardContent className="floatLeft w100">
                                        <List className="ClientDetailsList">
                                            <li><label>Last Logged In</label> <span
                                                    className="labelValue"> {lastLogin ? dateUtils.asDbDateFormat(lastLogin) : "NA"} </span>
                                            </li>
                                            <li>
                                                <label>Current Status</label> <span
                                                    className="labelValue colorBlue"> {currentPolicyStatus === PolicyStatusEnum.InForce || currentPolicyStatus === PolicyStatusEnum.InForceOverride ?
                                                    <ViewServicing
                                                            clientName={detail.firstName + " " + detail.lastName}
                                                            clientId={detail.client.id}
                                                            stratergyId={clientPolicy.strategyId}
                                                            carrierId={clientPolicy.carrierId}
                                                            clientPolicyId={clientPolicy.id}
                                                            btnText={"Policy Issued - View Servicing"} /> : (currentStatus === 22 ? PolicyStatusEnum.InForce : getPolicyStatus(currentStatus, currentPolicySubStatus))}
                                            </span>
                                            </li>
                                            {detail && detail.role === 6 &&
                                                    <li><label>Group Name </label> <span
                                                            className="labelValue">{companyName}</span>
                                                    </li>
                                            }
                                            {detail && detail.role === 5 && (clientPolicy && clientPolicy.clientListId) &&
                                                    <li><label>Client List </label> <span
                                                            className="labelValue colorBlue">{clientListName}</span>
                                                    </li>
                                            }

                                            <li>
                                                <label>Agent</label>
                                                {
                                                    <span className="labelValue">
                                                    {
                                                            advisor &&
                                                            (
                                                                    user && (user.role <= 3 || user.role === 15) ?
                                                                            <Link
                                                                                    component={RouterLink}
                                                                                    to={"/new-agent/detail/" + advisor.id}
                                                                            >
                                                                                {advisor.firstName + " " + advisor.lastName}
                                                                            </Link> :
                                                                            advisor.firstName + " " + advisor.lastName
                                                            )
                                                    }
                                                </span>
                                                }
                                            </li>
                                            {contributionAmount && !isGWTGen2 &&
                                                    <li><label>Annual Client Contribution</label> <span
                                                            className="labelValue">{numeral(contributionAmount).format("$0,0")}</span>
                                                    </li>}
                                            {source && <li><label>Source</label> <span
                                                    className="labelValue">{clientSource[source]}</span>
                                            </li>}
                                            {/*{employer && <li><label>Employer</label> <span className="labelValue">{employer}</span></li> }*/}
                                            {/*{employerContribution && <li><label>Employer Contribution</label> <span className="labelValue">${employerContribution}</span></li> }*/}

                                            <li>
                                                <label>Tranche Number</label> {
                                                    (user.role === 1 || user.role === 2) && !(policyRow) &&
                                                    <EditIcon className="f16 floatRight cursorPointer iconhover"
                                                              onClick={() => openTrancheSelect()} />
                                            }

                                                {
                                                        (user.role === 1 || user.role === 2) && (policyRow) &&
                                                        <LockIcon className="f16 floatRight textBlackLight"
                                                                  style={{ marginTop: 3 }} />
                                                } <span className="labelValue">{trancheNo > 0 ? trancheNo : "NA"}</span>

                                            </li>

                                            <li><label>{`Payment Deadline (Current Tranche ${trancheNo})`}:</label>
                                                <span className="labelValue valueHeighlight">
                                {clientPolicy && clientPolicy.tranche && clientPolicy.tranche.trancheNumber &&
                                        moment(clientPolicy && clientPolicy.tranche && clientPolicy.tranche.fundsDeadLineDate).format("MM/DD/YYYY")
                                }
                                                    {clientPolicy && clientPolicy.tranche && clientPolicy.tranche.trancheNumber &&
                                                            <BootstrapTooltip
                                                                    color="primary" className="floatRight pd0"
                                                                    title={`This is the date your first year contribution is due to ${strategyName}`}
                                                            >
                                                                <IconButton className="f16 floatRight"
                                                                            aria-label="delete">
                                                                    <InfoIcon />
                                                                </IconButton>
                                                            </BootstrapTooltip>
                                                    }
                            </span>
                                            </li>
                                            {clientPolicy && clientPolicy.tranche && clientPolicy.tranche.trancheNumber && !isGWTGen2 &&
                                                    <li><label>Projected Funding Date</label> <span
                                                            className="labelValue valueHeighlight">
                            {moment(clientPolicy && clientPolicy.tranche && clientPolicy.tranche.projectFundingDate).format("MM/DD/YYYY")}
                                                        <BootstrapTooltip
                                                                color="primary" className="floatRight pd0"
                                                                title="This is the date we project the lender will fund the full
                                         premium to your policy to put your plan inforce.">
                                                <IconButton className="f16 floatRight" aria-label="delete">
                                                    <InfoIcon />
                                                </IconButton>
                                            </BootstrapTooltip></span>
                                                    </li>
                                            }
                                            {
                                                    clientPolicy && clientPolicy.agent &&
                                                    <li><label>Agent Type</label>
                                                        <span className="labelValue">{clientPolicy.agent.agentType === 1 ? "Preferred" : "Approved"}</span>
                                                    </li>
                                            }
                                            {
                                                    clientPolicy && clientPolicy.carrier &&
                                                    <li><label>Carrier</label>
                                                        <span className="labelValue">{carrierName}</span>
                                                    </li>
                                            }

                                            <li><label>Product Type</label>
                                                <span className="labelValue">{strategyName}</span>
                                            </li>
                                            {
                                                    <li><label>Target Amount</label>
                                                        <span className="labelValue">{maskCurrencyWithDecimal(targetAmount)}</span>
                                                    </li>
                                            }                            
                                            {
                                                isGWTGen2 && detail.parentUser &&
                                                    <li style={{display:"flex", flexDirection:"row", justifyContent:"space-between"}}>
                                                        <label>Gen 1 Name</label>
                                                        <RouterLink to={detail.parentUser.profileUrl} className="labelValue"> {fullName(detail.parentUser)} </RouterLink>
                                                    </li>
                                            }

                                        </List>
                                    </CardContent>
                                </CardSnapshot>

                            </>
                }
                </>
    );
};

export const CardSnapshot = ({title, children}) => (
        <CardWithImage src={clientSnapshot} title={title}>
            {children}
        </CardWithImage>
)

export const CardWithImage = ({src, title, children}) => (
        <Card className="customCard boxShadow w100 mb20 mt50">
            <CardHeader
                    className="pb0"
                    avatar={
                        <img src={src} alt="#"/>
                    }
                    title={<React.Fragment>
                        <Typography
                                component="span"
                                variant="body1"
                        >
                            <strong>{title}</strong>
                        </Typography>
                    </React.Fragment>}
            />
            {children}
        </Card>
)
export default ClientSnapshot;